import Vue from 'vue'
import App from './App.vue'
// 清除基础样式
import './assets/styles/reset.css'
import router from './router'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
